import React from "react";
import Slider from "react-slick"; // Import the carousel library
import carWallpaper from "./../assets/images/carwallpaper.jpg"; // Import the wallpaper
import logo from "./../assets/images/logo.png.png"; // Import the logo
import owner1Photo from "./../assets/images/owner1.jpg.jpg"; // Import owner 1 photo
import owner2Photo from "./../assets/images/owner2.jpg.jpg"; // Import owner 2 photo
import "slick-carousel/slick/slick.css"; // Slick carousel default styles
import "slick-carousel/slick/slick-theme.css"; // Slick carousel theme styles
import "./../assets/styles.css"; // Your additional styles

function HomePage() {
  // Carousel settings
  const settings = {
    dots: true, // Display navigation dots
    infinite: true, // Infinite loop
    speed: 500, // Transition speed
    slidesToShow: 1, // Show one photo at a time
    slidesToScroll: 1, // Scroll one photo at a time
    autoplay: true, // Enable auto-slide
    autoplaySpeed: 3000, // Set auto-slide interval (3 seconds)
    arrows: false, // Hide the arrows
  };

  return (
    <section
      className="hero"
      style={{
        backgroundImage: `url(${carWallpaper})`, // Use the wallpaper as the background
        backgroundSize: "cover",
        backgroundPosition: "center",
        height: "100vh", // Full viewport height
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: "#fff", // White text
        position: "relative", // Enable absolute positioning for elements
        textAlign: "center",
        padding: "20px",
      }}
    >
      {/* Owner Carousel */}
      <div
        style={{
          position: "absolute",
          top: "20px",
          right: "20px",
          width: "220px", // Adjust carousel width
          textAlign: "center",
          color: "#fff",
          background: "rgba(0, 0, 0, 0.6)", // Semi-transparent background
          borderRadius: "10px",
          padding: "10px",
        }}
      >
        <Slider {...settings}>
          {/* Owner 1 */}
          <div>
            <img
              src={owner1Photo}
              alt="Owner 1"
              style={{
                width: "120px",
                height: "120px",
                borderRadius: "50%",
                objectFit: "cover",
                marginBottom: "10px",
              }}
            />
            <p style={{ fontSize: "16px", fontWeight: "bold" }}>Syed Shafiq</p>
            <p style={{ fontSize: "14px", color: "#ffd700" }}>+91 7676867700</p>
          </div>
          {/* Owner 2 */}
          <div>
            <img
              src={owner2Photo}
              alt="Owner 2"
              style={{
                width: "120px",
                height: "120px",
                borderRadius: "50%",
                objectFit: "cover",
                marginBottom: "10px",
              }}
            />
            <p style={{ fontSize: "16px", fontWeight: "bold" }}>Sameer Baig</p>
            <p style={{ fontSize: "14px", color: "#ffd700" }}>+91 9845245395</p>
          </div>
        </Slider>
      </div>

      {/* Main Content */}
      <div className="container">
        {/* Logo Section */}
        <div>
          <img
            src={logo}
            alt="STAR PRE-OWNED CARZ Logo"
            style={{
              width: "160px",
              marginBottom: "20px",
            }}
          />
        </div>
        <h2>Welcome to STAR PRE-OWNED CARZ</h2>
        <p>Your trusted destination for certified pre-owned cars.</p>
        <a href="/cars" className="btn">
          Explore Cars
        </a>
      </div>
    </section>
  );
}

export default HomePage;
